import * as React from "react";
const SvgFiRrPaperPlaneTop = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-paper-plane-top_svg__a)">
      <path
        fill="#062147"
        d="M21.916 8.727 3.965.282A2.745 2.745 0 0 0 .917.713a2.745 2.745 0 0 0-.745 2.995c.017.043 4.411 8.296 4.411 8.296S.27 20.255.255 20.297a2.74 2.74 0 0 0 .749 2.993 2.76 2.76 0 0 0 1.841.708c.409 0 .819-.092 1.201-.279l17.872-8.438A3.59 3.59 0 0 0 24 12.003c0-1.42-.801-2.676-2.084-3.276M2.032 2.967a.75.75 0 0 1 .223-.768.74.74 0 0 1 .838-.116l17.974 8.455c.239.112.438.27.591.462H6.315zm19.034 10.504L3.178 21.917a.74.74 0 0 1-.838-.116.74.74 0 0 1-.223-.769L6.319 13h15.345a1.65 1.65 0 0 1-.598.471"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-paper-plane-top_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPaperPlaneTop;
